// views
import View from '@views/complexes/list'
export default View

// i18n
import { getServerSidePropsI18n, GetServerSidePropsContext } from "@core/i18n/pageService/getServerPropsI18n"
import { tDict } from '@core/i18n/useTranslate'

// @ore
import { useEstate } from '@core/api'


export const getServerSideProps = async (context: GetServerSidePropsContext) => {


  // const { page, limit, ordering } = context.query

  const page = Number(context.query.page) || 1
  const limit = Number(context.query.limit) || 10

  const estate = useEstate()
  const complexesList = await estate.COMPLEX.list(page, limit).then((res) => {
    if (res.status === 200) {
      return res.data
    }
    return null
  })

  return getServerSidePropsI18n(context,
    {
      complexesList,
      config: {
        protected: false,
        appBar: {
          position: 'relative',
          // bgcolor: 'transparent',
          noContainer: true,
        },
        // footer: {
        //   size: 'hidden'
        // },
        plugins: {
          chat: false,
        },
        seo: {
          title: 'Complexes',
          // description: tDict.common.seo.main.description,
        },
      },
    },
    {
      namespacesRequired: ['common'],
    }
  )
};
